import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/GeminiChats.graphql';
import { Query, QuerygeminiChatsArgs } from '../../__generated__/globalTypes';

export const useGeminiChatsQuery = (options?: QueryHookOptions<Query, QuerygeminiChatsArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerygeminiChatsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useGeminiChatsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerygeminiChatsArgs>
): QueryResult<Query, QuerygeminiChatsArgs> & {
  getGeminiChats: LazyQueryExecFunction<Query, QuerygeminiChatsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getGeminiChats, result] = useLazyQuery<Query, QuerygeminiChatsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getGeminiChats, ...result };
};

export const useGeminiChatsPromiseQuery = () => {
  const client = useApolloClient();

  const getGeminiChats = useCallback(
    (options?: Omit<QueryOptions<QuerygeminiChatsArgs, Query>, 'query'>) =>
      client.query<Query, QuerygeminiChatsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getGeminiChats };
};
// Suspense Query Hooks
export const useGeminiChatsSuspenseQuery = (options?: SuspenseQueryHookOptions<Query, QuerygeminiChatsArgs>) => {
  const result = useSuspenseQuery<Query, QuerygeminiChatsArgs>(QUERY, {
    ...options
  });

  return result;
};
